import * as React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogDescription,
  DialogClose,
} from "@/components/ui/dialog";
import { OfferCard } from "@/components/offers/OfferCard";
import { OFFERS } from "@/components/offers/offer-data";
import { X } from "lucide-react";

export function OffersDialog({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (v: boolean) => void;
}) {
  const [openingBooking, setOpeningBooking] = React.useState(false);

  React.useEffect(() => {
    if (!open) return;
    document.body.classList.remove("booking-widget-opening");
    setOpeningBooking(false);
  }, [open]);

  if (openingBooking) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="offers-dialog-content max-w-3xl max-h-[90vh] bg-background border-foreground/10 overflow-hidden flex flex-col p-0"
        hideCloseButton
      >
        <DialogClose className="absolute right-4 top-4 z-[60] h-10 w-10 inline-flex items-center justify-center rounded-full bg-background/95 backdrop-blur-sm border border-foreground/15 shadow-lg opacity-80 hover:opacity-100 transition-opacity cursor-pointer">
          <X className="h-4 w-4" />
          <span className="sr-only">Close</span>
        </DialogClose>
        <div className="overflow-y-auto flex-1 p-6 md:p-8 pt-14">
          <div className="text-[10px] tracking-[0.4em] uppercase text-gold/90 mb-3">
            Limited-Time Offers
          </div>
          <DialogTitle asChild>
            <h2 className="font-serif text-3xl md:text-4xl text-foreground leading-tight">
              Make your next escape unforgettable.
            </h2>
          </DialogTitle>
          <DialogDescription asChild>
            <p className="text-foreground/70 font-light mt-3 text-[15px] leading-relaxed">
              These member offers may close as dates fill.
            </p>
          </DialogDescription>


          <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-5">
            {OFFERS.map((o) => (
              <OfferCard
                key={o.id}
                offer={o}
                beforeBookingOpen={async () => {
                  document.body.classList.add("booking-widget-opening");
                  setOpeningBooking(true);
                  onOpenChange(false);
                  await new Promise<void>((resolve) =>
                    window.setTimeout(resolve, 250),
                  );
                }}
              />
            ))}
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default OffersDialog;
